import { ArrowCounterClockwise, SpeakerHigh, SpeakerSlash } from "@phosphor-icons/react";
import { useKidsSound } from "@/hooks/useKidsSound";
import { replayLumi, useLumiAudioState } from "@/lib/lumiAudio";

// "Hear it again" control shared by the Kids Corner activities. Visible only when sound is on and Lumi has spoken.
export const LumiReplayButton = ({ className = "", testid = "lumi-replay-btn" }) => {
  const [soundOn] = useKidsSound();
  const { speaking, lastText } = useLumiAudioState();
  if (!soundOn) {
    return (
      <span className={`inline-flex items-center gap-1.5 font-nunito text-sm text-[#6a3fc7] ${className}`} data-testid="lumi-sound-off-note">
        <SpeakerSlash size={16} weight="bold" /> Sound is off
      </span>
    );
  }
  if (!lastText) return null;
  return (
    <button
      type="button"
      onClick={() => replayLumi()}
      disabled={speaking}
      aria-label="Hear Lumi again"
      className={`inline-flex items-center gap-1.5 h-10 px-4 rounded-full bg-white border border-[#d9ccf5] font-nunito font-bold text-sm text-[#4a2e8a] hover:bg-[#f3eefc] disabled:opacity-60 transition-colors focus-visible:ring-4 focus-visible:ring-[#b79cf0] ${className}`}
      data-testid={testid}
      data-speaking={speaking || undefined}
    >
      {speaking ? <SpeakerHigh size={18} weight="fill" className="animate-pulse" /> : <ArrowCounterClockwise size={18} weight="bold" />}
      {speaking ? "Lumi is talking…" : "Hear it again"}
    </button>
  );
};
